import { useSelector } from "react-redux";

/**
 * Why the composer is shut while a browser run owns the thread.
 *
 * A paused run is answered with the two review controls, not with a chat message: a stray
 * message supersedes the interrupt, which cancels the run and tears the browser down.
 */
export const COMPUTER_USE_CHAT_DISABLED_REASON =
  "Chat is disabled while Theo works in the browser panel.";

/** The reason for this thread, or null when no browser session is live in it. */
const useComputerUseChatDisabledReason = (
  aiThreadId: string | number | null | undefined
): string | null =>
  useSelector((state: any) => {
    const threadKey = aiThreadId != null ? String(aiThreadId) : null;
    if (!threadKey) return null;
    const runs = state?.chat?.computerUseByThreadId?.[threadKey]?.runs;
    if (!runs) return null;

    // A run that is merely waiting for its video has no browser to disturb and nothing to
    // supersede, so the composer reopens then rather than at the end of the whole job.
    const live = Object.values(runs as Record<string, { status?: string }>).some((run) =>
      run?.status === "executing" || run?.status === "waiting_on_customer"
    );
    return live ? COMPUTER_USE_CHAT_DISABLED_REASON : null;
  });

export default useComputerUseChatDisabledReason;
